/*
  Schwellenwerte in Maerkten mit anderer Waehrung.

  Die Geschenk- und Versandschwellen stehen als blanke Zahlen in den
  Theme-Einstellungen (99, 129, 149, Versand 79) und sind in Shop-Waehrung
  gemeint. Liquid vergleicht sie gegen cart.total_price — und das steht in der
  Waehrung des Marktes. In DK galt die erste Geschenkstufe damit ab 99 DKK
  statt ab 99 €, der Balken meldete bei 419 DKK (55 €) schon "alle Geschenke
  erreicht", waehrend die Free-Gift-App nichts in den Warenkorb legte.

  Nachgemessen am Live-Shop: die App rechnet in Shop-Waehrung. Bei 838 DKK
  (110 €) kam das Geschenk der 99-€-Stufe, bei 419 DKK (55 €) nicht. Der
  Balken muss also gegen umgerechnete Schwellen pruefen, dann stimmt er mit
  dem ueberein, was der Kunde tatsaechlich bekommt.

  An den Kurs kommt nur der Browser (Shopify.currency.rate), Liquid kennt ihn
  nicht. Deshalb rendert das Theme weiter wie bisher und dieses Skript zieht
  die Zustaende hinterher: erreichte Stufen, Balkenbreite, Betraege, Text.
  In Maerkten mit Kurs 1 — EUR und CHF, dessen Preise 1:1 gepflegt sind —
  passiert nichts, dort war die Rechnung nie falsch.

  Der Warenkorb wird per innerHTML ersetzt, wenn sich etwas aendert. Ein
  Observer sorgt dafuer, dass die Korrektur danach wieder laeuft.
*/
(function () {
  var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
  if (!(rate > 0) || rate === 1) return;

  function money(cents, dropZeroCents) {
    if (window.brekkyFormatMoney) return window.brekkyFormatMoney(cents, dropZeroCents);
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  // Betrag in Shop-Waehrung (Cent) -> Betrag im Markt (Cent)
  function toMarket(shopCents) {
    return Math.round(shopCents * rate);
  }

  // Schwellen und Restbetraege stehen im Theme als ganze Zahlen ("99€"), also
  // auch hier auf ganze Waehrungseinheiten runden statt 754,84 kr zu zeigen.
  function roundedMoney(marketCents) {
    return money(Math.round(marketCents / 100) * 100, true);
  }

  function attr(el, name) {
    return el && el.getAttribute(name);
  }

  // Die Korrektur schreibt selbst ins DOM und wuerde den Observer damit wieder
  // ausloesen. Jedes Element wird deshalb pro Warenkorbstand nur einmal
  // angefasst; nach einem Neurendern ist die Markierung mit dem alten Element
  // weg und es wird neu gerechnet.
  function alreadyDone(el, signature) {
    if (el.__marketThresholds === signature) return true;
    el.__marketThresholds = signature;
    return false;
  }

  // ===== Geschenk- und Versandbalken =====
  function fixGiftTier(root) {
    var cartCents = Number(attr(root, 'data-cart-total'));
    if (!isFinite(cartCents)) return;
    if (alreadyDone(root, cartCents)) return;

    // Warenkorbwert zurueck in Shop-Waehrung, denn dagegen sind die Schwellen
    // definiert und danach richtet sich die App.
    var cartShopCents = cartCents / rate;

    var steps = [].slice.call(root.querySelectorAll('[data-threshold]'))
      .map(function (el) {
        return {
          el: el,
          threshold: Number(el.getAttribute('data-threshold')) * 100,
          position: Number(el.getAttribute('data-position')) || 0,
          kind: el.getAttribute('data-kind') || 'gift',
          name: el.getAttribute('data-name') || '',
        };
      })
      .filter(function (s) { return isFinite(s.threshold) && s.threshold > 0; })
      .sort(function (a, b) { return a.threshold - b.threshold; });

    if (!steps.length) return;

    var next = null;
    var previous = { threshold: 0, position: 0 };

    steps.forEach(function (step) {
      var reached = cartShopCents >= step.threshold;
      step.el.classList.toggle('reached', reached);
      step.el.classList.remove('next');

      var label = step.el.querySelector('.gift-tier-progress__step-price');
      if (label) label.textContent = roundedMoney(toMarket(step.threshold));

      if (reached) {
        if (step.threshold > previous.threshold) previous = step;
      } else if (!next) {
        next = step;
      }
    });

    // Balkenbreite: zwischen der letzten erreichten und der naechsten Stufe
    // linear interpolieren — genauso, wie es Liquid tut.
    var progress = 100;
    if (next) {
      next.el.classList.add('next');
      var span = next.threshold - previous.threshold;
      var share = span > 0 ? (cartShopCents - previous.threshold) / span : 0;
      progress = previous.position + share * (next.position - previous.position);
      progress = Math.max(0, Math.min(100, progress));
    }
    root.style.setProperty('--gift-progress', progress + '%');

    // Text darunter
    var text = root.querySelector('.gift-tier-progress__text');
    if (!text) return;

    if (!next) {
      text.textContent = attr(root, 'data-text-achieved') || '';
      return;
    }

    var remaining = Math.max(0, next.threshold - cartShopCents);
    var tail;
    if (next.kind === 'shipping') {
      tail = attr(root, 'data-text-shipping') || '';
    } else if (next.name) {
      tail = (attr(root, 'data-text-gift') || '').replace('%name%', next.name);
    } else {
      tail = attr(root, 'data-text-suffix') || '';
    }

    text.textContent = '';
    text.appendChild(document.createTextNode((attr(root, 'data-text-prefix') || '') + ' '));
    var price = document.createElement('span');
    price.className = 'price';
    price.textContent = roundedMoney(toMarket(remaining));
    text.appendChild(price);
    text.appendChild(document.createTextNode(' ' + tail));
  }

  // ===== "Versandkosten: kostenlos" unten im Warenkorb =====
  function fixShippingLabel(root) {
    var threshold = Number(attr(root, 'data-free-shipping-threshold')) * 100;
    var cartCents = Number(attr(root, 'data-cart-total'));
    if (!isFinite(threshold) || !isFinite(cartCents)) return;

    if (alreadyDone(root, cartCents)) return;

    var free = cartCents / rate >= threshold;
    var yes = root.querySelector('[data-shipping-free]');
    var no = root.querySelector('[data-shipping-open]');
    if (yes) yes.hidden = !free;
    if (no) no.hidden = free;
  }

  // ===== Versandfortschritt (nur aktiv, wenn der Geschenkbalken aus ist) =====
  function fixProgressRange(root) {
    var threshold = Number(attr(root, 'data-free-shipping-threshold')) * 100;
    var cartCents = Number(attr(root, 'data-cart-total'));
    if (!isFinite(threshold) || !isFinite(cartCents)) return;

    if (alreadyDone(root, cartCents)) return;

    var missing = Math.max(0, threshold - cartCents / rate);
    root.style.setProperty('--shipping-progress', (missing / threshold) * 100 + '%');

    var priceEl = root.querySelector('.drawer-progress__price');
    if (priceEl) priceEl.textContent = roundedMoney(toMarket(missing));

    var reachedText = attr(root, 'data-text-reached');
    var textEl = root.querySelector('.drawer-progress__text');
    if (missing <= 0 && textEl && reachedText) textEl.textContent = reachedText;
  }

  // ===== Aufpreis-Label am Konfigurator =====
  // Der Betrag steht als fertiger Text in den Block-Settings bzw. im
  // Metaobjekt ("+ €1,8") und ist in Shop-Waehrung gemeint. Die Varianten
  // dahinter rechnet Shopify um, das Label blieb bisher in Euro stehen.
  function fixSurcharge(el) {
    // Nur einmal pro Element, sonst wuerde der schon umgerechnete Wert beim
    // naechsten Lauf noch einmal mit dem Kurs multipliziert.
    if (alreadyDone(el, 'surcharge')) return;

    var cents = window.brekkyParseMoney ? window.brekkyParseMoney(el.textContent) : NaN;
    if (!isFinite(cents) || cents <= 0) return;

    var prefix = /^\s*\+/.test(el.textContent) ? '+ ' : '';
    el.textContent = prefix + money(toMarket(cents), true);
  }

  function run() {
    document.querySelectorAll('[data-gift-tier]').forEach(fixGiftTier);
    document.querySelectorAll('[data-market-surcharge]').forEach(fixSurcharge);
    document.querySelectorAll('[data-shipping-label]').forEach(fixShippingLabel);
    document.querySelectorAll('[data-shipping-progress]').forEach(fixProgressRange);
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Der Warenkorb wird bei jeder Aenderung als ganzer Block ersetzt.
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
